import {useState} from "react";

export default function ExerciserEraseButton({isDisabled, onPressed}) {
    // Used in ExerciserValidationBar to display an erase button

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)

    // BUILD
    return(
        <div className={`select-none ${computeParentStyle()} w-full h-[48px] max-w-[96px] rounded-full flex justify-center items-center`}
             onClick={isDisabled ? null : onPressed}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)} >
            <i className={`${computeIconStyle()} material-icons text-[24px]`}>
                backspace
            </i>
        </div>
    )

    // METHODS
    // ---- UX : Compute parent style
    function computeParentStyle() {
        return isDisabled
            ? "bg-greyLight1 cursor-not-allowed"
            : isHovered
                ? "bg-secondaryLight1 cursor-pointer"
                : "bg-secondary cursor-pointer"
    }

    // ---- UX : Compute icon style
    function computeIconStyle() {
        return isDisabled
            ? "text-greyLight7"
            : "text-white"
    }
}